import { Form, useFormikContext } from 'formik';
import { makeStyles } from 'tss-react/mui';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import MLink from '@mui/material/Link';
import * as Yup from 'yup';
import { useAppContext } from '../../contexts/app';
import TextAreaField from '../forms/text-area-field';
import MaterialLink from '../material-link';
import FormSubmitStatus from '../forms/form-submit-status';
import FormikPersist from '../../utils/formik-persist';

const useStyles = makeStyles()((theme) => ({
  buttons: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
  submitButton: {
    marginRight: theme.spacing(2)
  },
  postingAs: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    width: 20,
    height: 20,
    margin: theme.spacing(0, 0.5, 0, 0.5)
  }
}));

export const newCommentSchema = Yup.object().shape({
  body: Yup.string().required('Message is required')
});

type Props = {
  disabled?: boolean;
  name?: string;
};

const NewEventCommentForm = ({ disabled: formDisabled, name }: Props) => {
  const { loggedInUser } = useAppContext();
  const { isSubmitting, submitCount } = useFormikContext();
  const { classes } = useStyles();
  const disabled = isSubmitting || formDisabled;
  const errorsDisabled = submitCount < 1;
  return (
    <Form>
      <TextAreaField
        name="body"
        label="Add a comment"
        disabled={disabled}
        errorsDisabled={errorsDisabled}
        helperText={(
          <span>
            <MLink href="https://www.markdownguide.org/basic-syntax/" target="_blank">
              Markdown
            </MLink>
            {' '}is supported
          </span>
        )}
      />

      <div className={classes.buttons}>
        <Button
          type="submit"
          disabled={disabled}
          variant="contained"
          color="primary"
          className={classes.submitButton}
        >
          Post
        </Button>
        {loggedInUser && (
          <div className={classes.postingAs}>
            Commenting as
            {' '}
            <Avatar
              alt={loggedInUser.displayName}
              src={loggedInUser.avatar?.small?.url}
              className={classes.avatar}
            />
            <MaterialLink href={`/people/${loggedInUser.username}`}>
              {loggedInUser.displayName}
            </MaterialLink>
          </div>
        )}
        <FormSubmitStatus />
      </div>
      <FormikPersist name={name} />
    </Form>
  );
};

export default NewEventCommentForm;
